Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var sharedStyles = _ref.sharedStyles;
  var paragraph = sharedStyles.paragraph,
    textColor = sharedStyles.textColor;
  var container = {
    marginBottom: paragraph.marginBottom,
    width: '100%'
  };
  var text = {
    fontSize: paragraph.fontSize,
    lineHeight: paragraph.lineHeight,
    fontFamily: paragraph.fontFamily,
    color: textColor || paragraph.color
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    text: text
  });
  return {
    styles: styles
  };
};